import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import SectorGeographyHierarchy from './DropdownHierarchy';
import Dropdown from './Dropdown';
import { DropdownHierarchyFilter } from './DropdownHierarchyFilter';
import DropdownFooter from './DropdownFooter';
import './MarketReportsInsights.scss';

interface CustomFilterDropdownProps {
  checkedSource: any[];
  isRightSideBarOpen?: boolean;
  isSideBarOpen?: boolean;
  filter: any;
  setInputFilter: boolean;
  treeNode: any;
  customCondition?: boolean;
  hasDefaultChecks?: boolean;
  defaultExpanded?: boolean;
  customCss?: string;
  toggleSelectedSource: () => void;
  setCheckBoxValue: (value: any) => void;
  setClearFilter?: boolean;
  placeholder?: string;
  title: string;
  clearAll: () => void;
  closeFilter: () => void;
  checkedNodes: any;
  onSearchbuttonClick: (flags?: string) => void;
  handleApplyOnFilters: (flags: any) => void;
  dropDownflags: any;
}

const CustomFilterDropdown: React.FC<CustomFilterDropdownProps> = ({
  onSearchbuttonClick,
  toggleSelectedSource,
  checkedSource,
  isRightSideBarOpen,
  isSideBarOpen,
  filter,
  setInputFilter,
  treeNode,
  setCheckBoxValue,
  setClearFilter,
  customCondition,
  hasDefaultChecks,
  defaultExpanded,
  customCss,
  placeholder,
  title,
  clearAll,
  closeFilter,
  checkedNodes = [],
  handleApplyOnFilters,
  dropDownflags
}) => {

  const memoizedCheckedNodes = useMemo(() => checkedNodes, [checkedNodes]);

  return (
    <>
      <div>
        <Dropdown
          options={[{ label: ' ', value: ' ' }]}
          onFocus={toggleSelectedSource}
          placeholder={placeholder}
          classCss={'no-class dropdown-parent-next'}
          showBackground={checkedSource?.length > 0 ? true : false}
          isSideBarOpen={isRightSideBarOpen}
        />
      </div>
      <div
        className={`${isRightSideBarOpen ? (isRightSideBarOpen && isSideBarOpen ? 'tableoverlapgeography-with-width-chat' : 'tableoverlapgeography-with-chat') : 'tableoverlapgeography'} ${customCss}`}>
        {dropDownflags !== 'report' && (
          <div className='hierarchy-box'>
            <DropdownHierarchyFilter
              filter={filter}
              placeholder={'Search'}
              setInputFilter={setInputFilter}
            />
          </div>
        )}

          <div className='sticky-filter'>
            <SectorGeographyHierarchy
              title={title}
              treeNode={treeNode}
              setCheckBoxValue={setCheckBoxValue}
              setClearFilter={setClearFilter}
              hasDefaultChecks={hasDefaultChecks}
              defaultExpanded={defaultExpanded}
              checkedNodes={memoizedCheckedNodes}
            />
          </div>

          <DropdownFooter clearAll={clearAll} closeFilter={closeFilter} onSearchbuttonClick={() => onSearchbuttonClick(dropDownflags)} 
              handleApplyOnFilters={handleApplyOnFilters} dropDownflags={dropDownflags}
              />
        </div>
    </>
  );
};

export default CustomFilterDropdown;
